import { render, staticRenderFns } from "./videoPlayer.vue?vue&type=template&id=de430f5a&scoped=true"
import script from "./videoPlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./videoPlayer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./videoPlayer.vue?vue&type=style&index=0&id=de430f5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de430f5a",
  null
  
)

export default component.exports